import { Download, FileText } from "lucide-react";

const EvidenceTab = ({ evidenceData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
             <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Evidence Repository</h3>
                  <p className="text-sm text-slate-500 mt-1">Artifacts and logs uploaded for control verification.</p>
                </div>
              </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
              {evidenceData.map((ev) => (
                <div key={ev.id} className="bg-white p-5 rounded-2xl ring-1 ring-slate-200/60 shadow-sm hover:shadow-md hover:ring-indigo-300 transition-all cursor-pointer group flex flex-col h-full">
                  <div className="flex justify-between items-start mb-4">
                    <div className={`p-3 bg-${ev.color}-50 text-${ev.color}-600 rounded-xl ring-1 ring-${ev.color}-100 group-hover:bg-indigo-500 group-hover:text-white transition-colors`}>
                      <FileText size={24} />
                    </div>
                    <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded-md tracking-widest ring-1 ring-slate-200/50">
                      {ev.control}
                    </span>
                  </div>
                  
                  <div className="flex-1">
                    <h4 className="text-sm font-bold text-slate-900 mb-1 line-clamp-2" title={ev.name}>{ev.name}</h4>
                    <p className="text-xs font-medium text-slate-500 mb-4">{ev.required}</p>
                  </div>

                  <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between">
                     <div className="flex flex-col">
                        <span className="text-[9px] font-bold uppercase tracking-widest text-slate-400">Uploaded By</span>
                        <span className="text-xs font-semibold text-slate-700">{ev.uploadedBy}</span>
                     </div>
                     <div className="flex items-center gap-3">
                        <span className="text-xs font-medium text-slate-400">{ev.date}</span>
                        <div className="p-1.5 bg-slate-50 text-slate-400 rounded-lg group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors">
                           <Download size={14} />
                        </div>
                     </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
    </>);
};

export default EvidenceTab;